export function initSentryScript() {
	const sentryScript = document.createElement('script');
	sentryScript.src = 'https://js.sentry-cdn.com/cfb3494495c55c086a1b2f077e365a24.min.js';
	sentryScript.crossOrigin = 'anonymous';
	document.head.append(sentryScript);
}
